module.exports = __webpack_public_path__ + "static/img/banner4.bd60b87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner4.png
// module id = y+J+
// module chunks = 1